import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/filters";

export default function WhatsAppFloat() {
    return (
        <motion.a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="whatsapp-floating-widget"
            aria-label="Chat with Deoeditz on WhatsApp"
            initial={{ opacity: 0, scale: 0.6 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 1.6, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            className="wa-pulse fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-amberx text-obsidian shadow-[0_8px_30px_rgba(255,159,28,0.4)] transition-transform hover:scale-105 active:scale-95"
        >
            <MessageCircle className="h-6 w-6" />
        </motion.a>
    );
}
